import './App.css';
import './assets/css/theme.css';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import Footer from './components/Footer';
import Header from './components/Header';
import Home from './components/Home/Home';
import Category from './components/Category';
import ProductDetail from './components/ProductDetail/ProductDetail';
import Checkout from './components/Checkout';
import 'bootstrap/dist/css/bootstrap.css';
import React, { useState, useEffect } from 'react';
import LoginModal from './components/LoginModal';
import RegisterModal from './components/RegisterModal';
import { Routes, Route, useLocation, Navigate } from 'react-router-dom';
import PrivateRoute from './components/Common/PrivateRoute';
import Cart from './components/Cart';
import Account from './components/User/Account'
import ChangePassword from './components/User/ChangePassword';
import Orders from './components/User/Orders';
import { useDispatch, useSelector } from 'react-redux';
import { raiseError } from './store/actions/action';
import ThankYou from './components/ThankYou';
import { isTokenExpired, loadStorage } from './Utils/Utils';
import { logOut } from './store/actions/action';
import { useNavigate } from 'react-router-dom';
import AllOrders from './components/User/AllOrders';
import AllUsers from './components/User/AllUsers';
import VerifyEmail from './components/VerifyEmail';
import AllCategories from './components/AllCategories';
import Toast from './components/Common/Toast';
import FooterPageView from './components/FooterPages/FooterPageView';
import { FOOTER_ROUTES, isFooterPath } from './components/FooterPages/footerRoutes';

function App() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [openLoginModal, setOpenLoginModal] = useState(false);
  const [openRegisterModal, setOpenRegisterModal] = useState(false);
  const response = useSelector((store) => store.response);
  const productDetail = useSelector((store) => store.products.data);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (loadStorage("token")) {
      const isExpired = isTokenExpired();
      if (isExpired) {
        dispatch(logOut());
        dispatch(raiseError("Plase login again"));
        navigate('/');
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Open login modal when redirected from a protected route
  useEffect(() => {
    if (location.state?.openLogin) {
      setOpenLoginModal(true);
      window.history.replaceState({}, '');
    }
  }, [location.state]);

  const isVerifyPage = location.pathname === '/verify-email';
  const isStaticPage = isVerifyPage || isFooterPath(location.pathname);

  const renderRoutes = () => {
    if (isStaticPage) {
      return (
        <Routes>
          <Route path="/verify-email" element={<VerifyEmail />} />
          {FOOTER_ROUTES.filter((r) => r.path !== '/').map((r) => (
            <Route key={r.path} path={r.path} element={<FooterPageView />} />
          ))}
        </Routes>
      );
    }
    if (!productDetail?.length) {
      return (
        <div className="d-flex justify-content-center mt-5">
          <div className="spinner-border" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      );
    }
    return (
      <Routes>
        <Route exact path="/" element={<Home />} />
        <Route path="/categories" element={<AllCategories />} />
        <Route path="/category" element={<Category />} />
        <Route path="/category/:categoryName" element={<Category />} />
        <Route path="/productDetail/:id" element={<ProductDetail />} />
        <Route path="/checkout/productId/:productId/quantity/:quantity" element={<PrivateRoute><Checkout /></PrivateRoute>} />
        <Route path="/checkout" element={<PrivateRoute><Checkout /></PrivateRoute>} />
        <Route path="/cart" element={<PrivateRoute><Cart /></PrivateRoute>} />
        <Route path="account/:target" element={<PrivateRoute><Account /></PrivateRoute>} />
        <Route path="/changepassword" element={<PrivateRoute><ChangePassword /></PrivateRoute>} />
        <Route path="/myOrders" element={<PrivateRoute><Orders /></PrivateRoute>} />
        <Route path="/AllOrders" element={<PrivateRoute><AllOrders /></PrivateRoute>} />
        <Route path="/AllUsers" element={<PrivateRoute><AllUsers /></PrivateRoute>} />
        <Route path="/thankYou" element={<PrivateRoute><ThankYou /></PrivateRoute>} />
        <Route path="/verify-email" element={<VerifyEmail />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    );
  };

  return (
    <div className="App">
      {response?.success && <Toast message={response.success} type="success" />}
      {response?.error   && <Toast message={response.error}   type="error"   />}

      <Header
        openLoginModal={openLoginModal}
        openRegisterModal={openRegisterModal}
        setOpenLoginModal={setOpenLoginModal}
        setOpenRegisterModal={setOpenRegisterModal}
      />
      {renderRoutes()}
      <Footer />
      {openLoginModal && <LoginModal setOpenLoginModal={setOpenLoginModal} openLoginModal={openLoginModal} setOpenRegisterModal={setOpenRegisterModal} />}
      {openRegisterModal && <RegisterModal setOpenRegisterModal={setOpenRegisterModal} setOpenLoginModal={setOpenLoginModal} />}
    </div>
  );
}

export default App;